import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { isPoaOnlyUser, POA_ONLY_ALLOWED_PATHS } from '@/lib/plan-access';

/** Keeps $197 POA buyers inside wizard / accounts / settings only. */
export default function PoaOnlyGuard({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return children;

  if (!isPoaOnlyUser(user)) {
    return children;
  }

  const allowed = POA_ONLY_ALLOWED_PATHS.some(
    (path) => location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  if (!allowed) {
    return <Navigate to="/poa-wizard" replace />;
  }

  return children;
}
